import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import '../App.css';
import html2canvas from 'html2canvas';
import logo from '../campofruver-blanco-y-negro-1.png'

const Tarjeta = ({ nombreTitular, numeroTarjeta, cvv, contactoTitular }) => {
    const qrRef = useRef(null);
    const cardRef = useRef(null);

   
    useEffect(() => {
        const qrData = `/search?nombre=${encodeURIComponent(nombreTitular)}&numero=${encodeURIComponent(numeroTarjeta)}&cvv=${encodeURIComponent(cvv)}&contacto=${encodeURIComponent(contactoTitular)}`;
        QRCode.toCanvas(qrRef.current, qrData, { width: 100 }, (error) => {
            if (error) console.error('Error generating QR code:', error);
        });
    }, [nombreTitular, numeroTarjeta, cvv, contactoTitular]);

    const handleDownload = () => {
        const card = cardRef.current;

        html2canvas(card).then((canvas) => {
            const link = document.createElement('a');
            link.download = `Tajeta ${nombreTitular}.jpg`;
            link.href = canvas.toDataURL('image/jpeg');
            link.click();
        }).catch((error) => {
            console.error('Error generando imagen:', error);
        });
    };

    return (
        <div>
            <div className="credit-card" ref={cardRef}>
                <div className="credit-card__content">
                    <div className="credit-card__number">
                        {numeroTarjeta.replace(/(.{4})/g, '$1 ')}
                    </div>
                    <div className="credit-card__info">
                    <canvas ref={qrRef} className="credit-card__qr"></canvas>
                   <img  className="credit-card__logo" src={logo} alt="" />
                        <div className="credit-card__name">{nombreTitular}</div>
                        <div className="credit-card__cvv">CVV: {cvv}</div>
                        <div className='info-card'>Obtén descuentos y promociones exclusivas con tu tarjeta cliente CampoFruver. Es unicamente de uso personal</div>
                 </div>
                </div>
            </div>
            <button className='btn btn-success' onClick={handleDownload}>Descargar Tarjeta</button>
            <a className={'btn btn-primary'}href={`https://web.whatsapp.com/send/?phone=57${contactoTitular}&text=hola+esta+es+tu+tarjeta+cliente+fiel` }  target="_blank">abrir wpp</a>
            
        </div>
    );
};

export default Tarjeta;
